import { Checkbox, FormControlLabel, FormHelperText, Grid, TextField } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import WorkforceSuggestionComponent from "../../../generic/workforcesuggestion/WorkforceSuggestionComponent";
import { teamList } from "../../../../components/recoil/teamsRecoil";
import { useRecoilValue } from "recoil";
import MemoryType from "../../../../service/memory/enum/MemoryType";
import { useReadMemory } from "../../../generic/hooks/useReadMemory";

const NewConversationForm = ({
  chatType = "direct",
  conversationDetails,
  setConversationDetails,
  errors,
  setErrors,
}) => {
  const isGroupChat = chatType === "group";
  const userJson = useReadMemory(MemoryType.USER);
  const teams = useRecoilValue(teamList);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConversationDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setConversationDetails((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const workforceEntityRecommenderPayloadData = useMemo(() => ({
    page: 1,
    organizationIdentifier: userJson?.organizationIdentifier,
    role: ["Volunteer", "Volunteer Coordinator"],
    userIdentifier: userJson?.userIdentifier,
    teamIds: teams?.map(team => team?.id)
  }), [userJson?.organizationIdentifier, userJson?.userIdentifier, teams]);

  const handleDataChange = useCallback((data) => {
    setConversationDetails((prev) => ({
      ...prev,
      selectedUsers: data.selectedUsers,
    }));

    if (data.selectedUsers?.length) {
      setErrors((prev) => {
        if (!prev?.selectedUsers) {
          return prev;
        }
        const { selectedUsers, ...rest } = prev;
        return rest;
      });
    }
  }, [setConversationDetails, setErrors]);

  return (
    <Grid container spacing={2}>
      {isGroupChat ? (
        <>
          <Grid xs={12} item>
            <TextField
              required
              fullWidth
              value={conversationDetails?.title ?? ""}
              name="title"
              label="Group name"
              variant="outlined"
              error={Boolean(errors?.title)}
              helperText={errors?.title}
              onChange={handleChange}
            />
          </Grid>
          <Grid xs={12} item>
            <TextField
              fullWidth
              value={conversationDetails?.topic ?? ""}
              name="topic"
              label="Topic (optional)"
              variant="outlined"
              onChange={handleChange}
              multiline
              rows={2}
              sx={{ height: "auto", "& .MuiInputBase-root": { height: "auto" } }}
            />
          </Grid>
          <Grid xs={12} item>
            <FormControlLabel
              control={
                <Checkbox
                  name="adminOnly"
                  checked={Boolean(conversationDetails?.adminOnly)}
                  onChange={handleCheckboxChange}
                />
              }
              label="Only admins can send messages"
            />
          </Grid>
        </>
      ) : null}
      <Grid xs={12} item>
        {errors?.selectedUsers && (
          <FormHelperText error>{errors.selectedUsers}</FormHelperText>
        )}
        <WorkforceSuggestionComponent
          key={chatType}
          handleSelectedUserData={handleDataChange}
          workforceEntityRecommenderPayloadData={workforceEntityRecommenderPayloadData}
          showSelectAll={isGroupChat}
          isMultiSelect={isGroupChat}
        />
      </Grid>
    </Grid>
  );
};

export default NewConversationForm;
